export default class CoreStorage {
  constructor(parent) {
    this.$parent = parent;
  }

  get() {
    const ls = window.localStorage.getItem('mini.mag:core');

    if (!ls) {
      return {};
    }
    const data = JSON.parse(ls);
    return {
      agency: data.agency,
      login: data.login,
      user: data.user,
    };
  }

  set({ agency = '', login = '', user = '' }) {
    window.localStorage.setItem('mini.mag:core', JSON.stringify({
      agency,
      login,
      user,
    }));
  }
}
